import React from "react";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { type DropdownProps } from "../models";

const StateDropdown = (props: DropdownProps<server.dto.State>) => {
  return <BaseReactSelectDropdown
    excludeKeys={props.excludeKeys}
    value={props.value}
    onChange={props.onChange}
    options={props.options.map(s => ({ ...s, name: s.name ?? "\u200b" }))} // Add zero-width space to prevent empty string
    getLabel={state => state?.name}
    getValue={state => state?.key}
    config={{
      isSearchable: true,
      ...props.config
    }}
  />;
};

export default StateDropdown;